"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSetTwoFactorRequiredRequestStatus = exports.getSetTwoFactorNotRequiredRequestStatus = exports.getFetchTwoFactorRequiredEnforcementRequestStatus = void 0;

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var getFetchTwoFactorRequiredEnforcementRequestStatus = (0, _getRequestStatus.default)(_actions.TwoFactorAuthActionTypes.FETCH_TWO_FACTOR_REQUIRED_ENFORCEMENT);
exports.getFetchTwoFactorRequiredEnforcementRequestStatus = getFetchTwoFactorRequiredEnforcementRequestStatus;
var getSetTwoFactorNotRequiredRequestStatus = (0, _getRequestStatus.default)(_actions.TwoFactorAuthActionTypes.SET_TWO_FACTOR_NOT_REQUIRED);
exports.getSetTwoFactorNotRequiredRequestStatus = getSetTwoFactorNotRequiredRequestStatus;
var getSetTwoFactorRequiredRequestStatus = (0, _getRequestStatus.default)(_actions.TwoFactorAuthActionTypes.SET_TWO_FACTOR_REQUIRED);
exports.getSetTwoFactorRequiredRequestStatus = getSetTwoFactorRequiredRequestStatus;